import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=5afdd031&lang=pug&"
import script from "./CardList.vue?vue&type=script&lang=ts&"
export * from "./CardList.vue?vue&type=script&lang=ts&"
import style0 from "./CardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afdd031')) {
      api.createRecord('5afdd031', component.options)
    } else {
      api.reload('5afdd031', component.options)
    }
    module.hot.accept("./CardList.vue?vue&type=template&id=5afdd031&lang=pug&", function () {
      api.rerender('5afdd031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cvtool-pages/CardList.vue"
export default component.exports